// Middleware stuffs
import store from '@/store';

const defaultRouteName = window.appConfig.SCB_BILLING_APP_MODE === 'admin' ?
  process.env.DEFAULT_ROUTE_NAME : process.env.DEFAULT_BILLER_ROUTE_NAME;

const routerMiddleware = {
  pageTitle(to, from, next) {
    document.title = to.meta.title;
    return next();
  },
  checkIsLogin(to, from, next) {
    if (store.getters.isAuthenticated) {
      if (store.getters.needResetPwd) {
        return next({ name: 'ResetPassword' });
      }
      return next({ name: defaultRouteName });
    }
    return next();
  },
  requireAuthenticated(to, from, next) {
    if (!store.getters.isAuthenticated) {
      return next({ name: 'Login' });
    } else if (store.getters.needResetPwd && ['ResetPassword', 'Logout'].indexOf(to.name) === -1) {
      return next({ name: 'ResetPassword' });
    }
    return next();
  },
};

export default routerMiddleware;



// WEBPACK FOOTER //
// ./src/router/middleware.js